import React, { Component } from 'react';
import utils from '../../common/utils';

import './myWeal.scss';
import Server from '../../common/server';

class Medal extends Component {
  constructor(props, context){
    super(props)
    this.state = {
      noClass: false,
      myWealData: [],
      totalPages: null,
      page: 1
    }
  }
  componentDidMount() {
    var me = this
    let from = utils.getParamFromURL('from')
    if (from === 'gradeUpdate') {
      setTimeout(()=> {
        // 通过页面上链接带有的gradeUpdate参数来判断是否需要将页面滚动到指定位置，如果含有gradeUpdate参数，页面则需要滚动到指定位置
        var timer = setInterval(() => {
          //变量scrollTop是滚动条滚动时，距离顶部的距离
          var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
          //变量windowHeight是可视区的高度
          var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
          //变量scrollHeight是滚动条的总高度
          var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
          //滚动条到底部的条件
          // 防止页面滚动到底部了但是目标元素（由于高度原因）没有滚动到指定位置导致定时器没有被clear。
          if(scrollTop + windowHeight === scrollHeight){
            clearInterval(timer)
          }
          let winScrollTop = document.documentElement.scrollTop
          let targetHeight = document.getElementsByClassName('my_weal')[0].offsetTop
          window.scrollBy(0, 10)
          if (winScrollTop >= (targetHeight - 100)) {
            clearInterval(timer)
          }
        }, 10)
      }, 500)
    }
    this.init()
  }
  noClass() {
    if (this.state.noClass) {
      return <li className="no_class">没有更多了</li> ;
    }
    return
  }
  // 页面初始化
  init() {
    var me = this
    // 获取用户已经获取到的礼品
    Server.getUserWelfare({
      page: 1
    }, function(json) {
      if (json.data.totalPages === 1) {
        me.setState({
          noClass: true,
        })
      }
      me.setState({
        page: 1,
        myWealData: json.data.content,
        totalPages: json.data.totalPages
      });
    })
    // 处理，页面被拉到底部时，再去加载新的资源
    window.onscroll = function(){
      if (me.state.totalPages === me.state.page) return
      var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
      //滚动条到底部的条件
      if(scrollTop + windowHeight === scrollHeight){
        me.setState({
          page: me.state.page + 1
        }, function () {
          if (!me.state.noClass) {
            Server.getUserWelfare({ page: me.state.page }, function (json) {
              if (json.data.totalPages === me.state.page) {
                me.setState({
                  noClass: true,
                })
              }
              me.setState({
                myWealData: me.state.myWealData.concat(json.data.content)
              });
            })
          }
        });
      }   
    }
  }
  render() {
    return (
      <div className="my_weal">
        {
          this.state.myWealData.length !== 0 && <h5 className="color-text-1">我的福利</h5>
        }
        <ul>
          {
           this.state.myWealData.map((item, index) =>
              <li key={index.toString()}>
                <a href={`yddict://youdao.com/listening?page=column&id=${item.name}`}>
                  <img src={item.image} />
                  <div className="class_contact">
                    <p className="color-text-1">{item.title}</p>
                    <span className="color-text-2">{item.intro}</span>
                  </div>
                  <div className="people">
                    {
                      this.props.dark ? <img className="level_count" src="http://ydschool-online.nos.netease.com/1573632509410%E6%99%8B%E7%BA%A7%E7%A6%8F%E5%88%A9%402x.png" /> : <img className="level_count" src="http://ydschool-online.nos.netease.com/1572429157424lv4%E7%A6%8F%E5%88%A9%402x.png" />
                    }
                    <p className="pepple_count color-text-3">
                      {item.visitNum}人正在听
                    </p>
                  </div>

                </a>
              </li>
            )
          }
          {this.noClass()}
        </ul>
      </div>
				
    );
  }
}

export default Medal;
